import React from 'react';

import PremiumFeaturesColumn from '../components/premium/premium_features_column';
import SchoolPremium from '../components/premium/school_premium.jsx';
import { PostNavigationBanner, LARGE_ICON_BASE_SRC, } from '../../Shared/index'

export const PremiumPricingGuide = ({ customerEmail, }) => {
  const userIsSignedIn = () => {
    return !!customerEmail
  }

  return (
    <div className="container premium-page">
      <h1>Go Premium, Boost Outcomes</h1>
      <p className="page-subheader">As a nonprofit, Quill provides all activities for free, forever. <br /><br />Quill Premium is designed for schools and districts ready to make a systemic impact on literacy instruction. With features like schoolwide professional learning, advanced reporting, and priority support, Premium helps educators amplify student outcomes and build a cohesive, evidence-driven approach to writing instruction.</p>
      <section className="premium-features-columns-wrapper">
        <PremiumFeaturesColumn
          subheader="Free for Teachers"
          subheaderButton={userIsSignedIn() ? <span className="button-placeholder" /> :<a className="quill-button contained medium green focus-on-dark" href="/account/new">Sign up free</a>}
          subheaderDescription="No contract"
          title="Teacher Basic"
        />
        <PremiumFeaturesColumn
          subheader="Unlimited Teachers & Students"
          subheaderButton={<a className="quill-button contained medium maroon focus-on-dark" href="/request_quote">Get a quote</a>}
          subheaderDescription="For one school site"
          title="School Premium"
        />
        <PremiumFeaturesColumn
          subheader="District-Wide Implementations"
          subheaderButton={<a className="quill-button contained medium maroon focus-on-dark" href="/request_quote">Get a quote</a>}
          subheaderDescription="With discounts for multi-year plans"
          title="District Premium"
        />
      </section>
      <PostNavigationBanner
        bannerColor="grey"
        bannerStyle="light-mode"
        bodyText="Teachers can purchase an individual Premium license to access Premium reports."
        buttons={[
          {
            href: "/teacher_premium",
            text: "Teacher Premium Page"
          }
        ]}
        icon={{ alt: "", src: `${LARGE_ICON_BASE_SRC}/premium.svg` }}
        primaryHeaderText="Teacher Premium"
      />

      <div className="features text-center">
        <SchoolPremium />
      </div>
    </div>
  )
}

export default PremiumPricingGuide
